<div
  class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 backdrop-blur-md p-4 transition-opacity duration-300 animate-fade-in"
  [class.opacity-0]="!isVisible" [class.opacity-100]="isVisible" (click)="onClose()">

  <div
    class="bg-white dark:bg-slate-900 w-full max-w-6xl rounded-[2.5rem] shadow-2xl overflow-hidden transition-all duration-300 relative text-slate-800 dark:text-slate-200 border border-slate-100/50 dark:border-slate-800/50 flex flex-col h-[90vh]"
    [class.translate-y-4]="!isVisible" [class.translate-y-0]="isVisible" (click)="$event.stopPropagation()">

    <!-- Decorative Backdrop Blobs -->
    <div class="absolute top-1/4 left-1/4 w-72 h-72 bg-amber-400/5 rounded-full blur-3xl pointer-events-none -z-10">
    </div>
    <div class="absolute bottom-1/4 right-1/4 w-80 h-80 bg-blue-400/5 rounded-full blur-3xl pointer-events-none -z-10">
    </div>

    <!-- Modal Header -->
    <div
      class="flex items-center justify-between px-8 py-5 border-b border-slate-100 dark:border-slate-800/80 shrink-0">
      <div class="flex items-center gap-3">
        <div
          class="w-10 h-10 rounded-2xl bg-amber-400/10 dark:bg-amber-400/20 flex items-center justify-center text-amber-500 shadow-[0_0_15px_rgba(251,191,36,0.2)]">
          <span class="material-icons">track_changes</span>
        </div>
        <div *ngIf="!isLoading">
          <h2 class="text-lg font-black text-slate-900 dark:text-white flex items-center gap-2">
            ติดตามเคสปัญหารายการ: {{ caseDetail.caseNo }}
            <span
              [class]="'px-2.5 py-0.5 rounded-full text-[9px] font-black tracking-wide uppercase ' + getPriorityColorClass(caseDetail.priority)">
              ความสำคัญ: {{ getPriorityLabel(caseDetail.priority) }}
            </span>
          </h2>
          <p class="text-[12px] text-slate-500 dark:text-slate-400 font-medium">
            เจ้าหน้าที่ผู้เปิดเคสและติดตามประวัติการแก้ไขเรื่องทั้งหมด</p>
        </div>
        <div *ngIf="isLoading">
          <h2 class="text-lg font-black text-slate-900 dark:text-white">กำลังโหลดข้อมูล...</h2>
        </div>
      </div>
      <div class="flex items-center gap-2">
        <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()"
          class="px-4 py-2 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-500 font-bold hover:border-amber-400 hover:text-amber-600 transition-all cursor-pointer inline-flex items-center gap-1.5 text-xs bg-transparent">
          <span class="material-icons text-base">history</span>
          ดูประวัติ
        </button>
        <button (click)="onClose()"
          class="w-8 h-8 flex items-center justify-center rounded-xl bg-slate-50 hover:bg-slate-100 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 transition-colors cursor-pointer border-none">
          <span class="material-icons text-sm">close</span>
        </button>
      </div>
    </div>

    <!-- Loader -->
    <div *ngIf="isLoading" class="flex-1 flex flex-col items-center justify-center space-y-3">
      <div class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
      <span class="text-[12px] font-bold text-slate-400">กำลังดึงข้อมูลรายละเอียดและไทม์ไลน์...</span>
    </div>

    <!-- Split-Pane Content -->
    <div *ngIf="!isLoading" class="flex-1 flex flex-col md:flex-row overflow-hidden min-h-0">

      <!-- LEFT PANE: Case Metadata Dashboard -->
      <div
        class="w-full md:flex-[3] md:min-w-0 border-r border-slate-100 dark:border-slate-850 p-6 overflow-y-auto custom-scrollbar space-y-5 bg-slate-50/40 dark:bg-slate-900/10 shrink-0">

        <!-- Time Elapsed Banner -->
        <div *ngIf="caseDetail && caseDetail.createDate"
          [class]="'relative overflow-hidden border p-4 rounded-3xl shadow-sm flex items-center gap-3 transition-all duration-300 ' + 
            (getCaseDurationInfo(caseDetail).isCompleted ? 
              'bg-gradient-to-r from-emerald-500/10 via-emerald-600/10 to-emerald-500/10 dark:from-emerald-500/20 dark:via-emerald-600/20 dark:to-emerald-500/20 border-emerald-500/20 dark:border-emerald-500/30 animate-glowing-green' : 
              'bg-gradient-to-r from-amber-500/10 via-amber-600/10 to-amber-500/10 dark:from-amber-500/20 dark:via-amber-600/20 dark:to-amber-500/20 border-amber-500/20 dark:border-amber-500/30 animate-glowing-amber'
            )">
          <!-- Decorative pulsing blob in bg -->
          <div [class]="'absolute -right-4 -bottom-4 w-16 h-16 rounded-full blur-xl pointer-events-none ' + 
            (getCaseDurationInfo(caseDetail).isCompleted ? 'bg-emerald-400/20' : 'bg-amber-400/20')"></div>

          <!-- Pulsing dot icon -->
          <div [class]="'relative w-9 h-9 rounded-2xl flex items-center justify-center shrink-0 shadow-inner ' + 
            (getCaseDurationInfo(caseDetail).isCompleted ? 'bg-emerald-500/20 text-emerald-500' : 'bg-amber-500/20 text-amber-500')">
            <span class="material-icons text-lg animate-spin-slow">schedule</span>
            <span *ngIf="!getCaseDurationInfo(caseDetail).isCompleted" class="absolute top-0 right-0 w-2.5 h-2.5 rounded-full bg-rose-500 border border-white dark:border-slate-900 animate-ping"></span>
            <span *ngIf="!getCaseDurationInfo(caseDetail).isCompleted" class="absolute top-0 right-0 w-2.5 h-2.5 rounded-full bg-rose-500 border border-white dark:border-slate-900"></span>
          </div>

          <div class="flex-1 min-w-0">
            <div class="text-[10px] font-black text-slate-500 dark:text-slate-400 uppercase tracking-widest leading-none">
              {{ getCaseDurationInfo(caseDetail).label }}
            </div>
            <div [class]="'text-[15px] font-black tracking-tight mt-1 truncate ' + 
              (getCaseDurationInfo(caseDetail).isCompleted ? 'text-emerald-600 dark:text-emerald-400' : 'text-amber-600 dark:text-amber-400')">
              {{ getCaseDurationInfo(caseDetail).duration }}
            </div>
          </div>
        </div>

        <!-- Case Info Card -->
        <div
          class="bg-white dark:bg-slate-800 rounded-3xl p-5 border border-slate-100 dark:border-slate-750 shadow-sm space-y-4">
          <div class="flex justify-between items-center pb-3 border-b border-slate-100 dark:border-slate-700/50">
            <span class="text-[12px] font-black text-slate-400 uppercase tracking-wider">ข้อมูลพื้นฐานเคส</span>
            <span
              [class]="'px-2.5 py-1 rounded-xl text-[12px] font-extrabold ' + getStatusColorClass(caseDetail.status)">
              {{ getStatusLabel(caseDetail.status) }}
            </span>
          </div>

          <div class="space-y-3">
            <div>
              <div class="text-[12px] text-slate-400 font-bold uppercase">หัวข้อแจ้งเรื่อง</div>
              <div class="text-[12px] font-extrabold text-slate-800 dark:text-slate-200 mt-0.5">{{ caseDetail.subject }}
              </div>
            </div>

            <div>
              <div class="text-[12px] text-slate-400 font-bold uppercase">รายละเอียด</div>
              <div
                class="text-[13px] font-semibold text-slate-600 dark:text-slate-300 mt-1 min-h-[120px] max-h-56 overflow-y-auto custom-scrollbar bg-slate-50/50 dark:bg-slate-900/40 p-3 rounded-xl border border-slate-100 dark:border-slate-800/80 leading-relaxed whitespace-pre-line">
                {{ caseDetail.description || '-' }}
              </div>
            </div>

            <div class="grid grid-cols-2 gap-3 text-[12px]">
              <div>
                <span class="text-[12px] text-slate-400 font-bold block uppercase">ช่องทางแจ้งเรื่อง</span>
                <span class="font-extrabold text-slate-800 dark:text-slate-200">{{ getChannelLabel(caseDetail.channel)
                  }}</span>
              </div>
              <div>
                <span class="text-[12px] text-slate-400 font-bold block uppercase">ลานจอด (Site)</span>
                <span class="font-extrabold text-slate-800 dark:text-slate-200 truncate block"
                  [title]="caseDetail.siteName || '-'">
                  {{ caseDetail.siteName || '-' }}
                </span>
              </div>
            </div>

            <div class="grid grid-cols-2 gap-3 text-[12px] pt-1">
              <div>
                <span class="text-[12px] text-slate-400 font-bold block uppercase">วันที่เปิดเรื่อง</span>
                <span class="font-bold text-slate-700 dark:text-slate-300">{{ caseDetail.createDate | date:'dd/MM/yyyy
                  HH:mm' }} น.</span>
              </div>
              <div>
                <span class="text-[12px] text-slate-400 font-bold block uppercase">SLA ดำเนินการ</span>
                <span class="font-bold text-slate-700 dark:text-slate-300">
                  {{ caseDetail.slaDueAt ? (caseDetail.slaDueAt | date:'dd/MM/yyyy HH:mm') + ' น.' : '-' }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Customer Card -->
        <div
          class="bg-white dark:bg-slate-800 rounded-3xl p-5 border border-slate-100 dark:border-slate-750 shadow-sm space-y-3">
          <div
            class="text-[12px] font-black text-slate-400 uppercase tracking-wider pb-2 border-b border-slate-100 dark:border-slate-700/50 flex items-center gap-1.5">
            <span class="material-icons text-[12px] text-slate-400">person</span>
            ข้อมูลผู้แจ้งเรื่อง
          </div>
          <div class="space-y-2.5 text-[12px]">
            <div>
              <span class="text-[12px] text-slate-400 font-bold block">ลูกค้าผู้ลงทะเบียน LINE</span>
              <span class="font-extrabold text-slate-800 dark:text-slate-200">{{ caseDetail.customerDisplayName || '-'
                }}</span>
            </div>
            <div>
              <span class="text-[12px] text-slate-400 font-bold block">ชื่อผู้ติดต่อแจ้งประสานงาน</span>
              <span class="font-bold text-slate-700 dark:text-slate-300">{{ caseDetail.contactName || '-' }}</span>
            </div>
            <div>
              <span class="text-[12px] text-slate-400 font-bold block">เบอร์โทรศัพท์ติดต่อกลับ</span>
              <span class="font-bold text-slate-700 dark:text-slate-300">{{ caseDetail.contactPhone || '-' }}</span>
            </div>
          </div>
        </div>

        <!-- Assignment Info -->
        <div
          class="bg-white dark:bg-slate-800 rounded-3xl p-5 border border-slate-100 dark:border-slate-750 shadow-sm space-y-3">
          <div
            class="text-[12px] font-black text-slate-400 uppercase tracking-wider pb-2 border-b border-slate-100 dark:border-slate-700/50 flex items-center gap-1.5">
            <span class="material-icons text-[12px] text-slate-400">assignment_ind</span>
            การมอบหมายงาน
          </div>
          <div class="flex items-center justify-between text-[13px]">
            <div>
              <span class="text-[12px] text-slate-400 font-bold block">เจ้าหน้าที่รับผิดชอบ</span>
              <span class="font-extrabold text-slate-800 dark:text-slate-200">
                {{ caseDetail.assignedUserName ? caseDetail.assignedUserName : 'ยังไม่มอบหมาย' }}
              </span>
            </div>
            <button *ngIf="canUpdate && caseDetail.status !== 'closed' && caseDetail.status !== 'cancelled'"
              (click)="openAssignDialog()"
              class="px-3 py-1.5 bg-slate-50 dark:bg-slate-750 hover:bg-slate-100 dark:hover:bg-slate-700 text-amber-500 font-bold rounded-xl text-[12px] transition-colors border-none cursor-pointer">
              แก้ไข
            </button>
          </div>
        </div>

        <!-- Cancellation/Resolution logs (Conditional) -->
        <div *ngIf="caseDetail.status === 'cancelled' && caseDetail.cancelReason"
          class="bg-rose-50/50 dark:bg-rose-950/10 border border-rose-100 dark:border-rose-900/50 rounded-3xl p-5 space-y-2">
          <div
            class="text-[12px] font-black text-rose-500 dark:text-rose-400 uppercase tracking-wider flex items-center gap-1.5">
            <span class="material-icons text-[12px]">error_outline</span>
            เหตุผลการยกเลิกเคส
          </div>
          <p class="text-[12px] font-semibold text-rose-700 dark:text-rose-350 leading-relaxed">{{
            caseDetail.cancelReason
            }}</p>
        </div>

        <div *ngIf="caseDetail.resolutionSummary"
          class="bg-green-50/50 dark:bg-green-950/10 border border-green-100 dark:border-green-900/50 rounded-3xl p-5 space-y-2">
          <div
            class="text-[12px] font-black text-green-600 dark:text-green-400 uppercase tracking-wider flex items-center gap-1.5">
            <span class="material-icons text-[12px]">check_circle_outline</span>
            สรุปผลการแก้ไขปัญหา
          </div>
          <p class="text-[12px] font-semibold text-slate-700 dark:text-slate-300 leading-relaxed">{{
            caseDetail.resolutionSummary }}</p>
        </div>

        <!-- Saved Images (read-only) -->
        <div
          class="bg-white dark:bg-slate-800 rounded-3xl p-5 border border-slate-100 dark:border-slate-750 shadow-sm space-y-3">
          <div
            class="text-[12px] font-black text-slate-400 uppercase tracking-wider pb-2 border-b border-slate-100 dark:border-slate-700/50 flex items-center gap-1.5">
            <span class="material-icons text-[12px] text-slate-400">photo_library</span>
            รูปหลักฐาน / แนบไฟล์
          </div>

          <div *ngIf="(caseDetail.images?.length || 0) > 0" class="grid grid-cols-3 gap-2">
            <button type="button" *ngFor="let img of caseDetail.images" (click)="openImagePreview(img.imageUrl)"
              class="relative aspect-square rounded-2xl overflow-hidden border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 cursor-pointer p-0">
              <img [src]="img.imageUrl" [alt]="img.caption || img.purpose" class="w-full h-full object-cover" />
            </button>
          </div>
          <p *ngIf="!(caseDetail.images?.length)" class="text-[12px] text-slate-400 font-medium">ยังไม่มีรูปที่บันทึก</p>
        </div>

      </div>

      <!-- RIGHT PANE: Interactive Timeline Activity Logs -->
      <div class="w-full md:flex-[2] md:min-w-0 flex flex-col overflow-hidden min-h-0 bg-white dark:bg-slate-900 p-4">

        <!-- Timeline Controls Header -->
        <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-2 pb-3 border-b border-slate-100 dark:border-slate-800/80 shrink-0">
          <span class="text-[11px] font-black text-slate-400 uppercase tracking-wider">บันทึกประวัติการดำเนินงาน
            (Timeline)</span>

          <!-- Actions dropdown or row -->
          <div *ngIf="canUpdate && caseDetail.status !== 'closed' && caseDetail.status !== 'cancelled'"
            class="flex flex-wrap items-center gap-2">
            <!-- Received -> In Progress -->
            <button *ngIf="caseDetail.status === 'received'" (click)="openStatusDialog('in_progress')"
              class="px-3 py-1.5 bg-blue-500 hover:bg-blue-600 text-white font-bold rounded-xl text-[12px] cursor-pointer transition-all border-none">
              เริ่มดำเนินการ
            </button>

            <!-- In Progress -> Waiting Customer -->
            <button *ngIf="caseDetail.status === 'in_progress'" (click)="openStatusDialog('waiting_customer')"
              class="px-3 py-1.5 bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold rounded-xl text-[12px] cursor-pointer transition-all border-none">
              รอข้อมูลเพิ่มเติม
            </button>

            <!-- Waiting Customer / Awaiting Confirm -> back to In Progress -->
            <button *ngIf="caseDetail.status === 'waiting_customer' || caseDetail.status === 'awaiting_customer_confirm'"
              (click)="openStatusDialog('in_progress')"
              class="px-3 py-1.5 bg-blue-500 hover:bg-blue-600 text-white font-bold rounded-xl text-[12px] cursor-pointer transition-all border-none">
              กลับไปดำเนินการ
            </button>

            <!-- In Progress / Waiting / Awaiting -> Closed (staff closes directly) -->
            <button
              *ngIf="caseDetail.status === 'in_progress' || caseDetail.status === 'waiting_customer' || caseDetail.status === 'awaiting_customer_confirm'"
              (click)="openStatusDialog('closed')"
              class="px-3 py-1.5 bg-emerald-500 hover:bg-emerald-600 text-white font-bold rounded-xl text-[12px] cursor-pointer transition-all border-none">
              ปิดงาน
            </button>

            <!-- Cancel -->
            <button (click)="openCancelDialog()"
              class="px-3 py-1.5 bg-rose-50 dark:bg-rose-950/20 hover:bg-rose-100 dark:hover:bg-rose-900/30 text-rose-500 font-bold rounded-xl text-[12px] cursor-pointer transition-all border-none">
              ยกเลิกเคส
            </button>
          </div>
        </div>

        <!-- Timeline Log List -->
        <div class="flex-1 overflow-y-auto custom-scrollbar my-3 pr-1 space-y-3 min-h-0">

          <div *ngFor="let log of caseDetail.logs" class="flex gap-2.5 relative group">

            <!-- Timeline vertical track line -->
            <div
              class="absolute left-3.5 top-7 bottom-[-12px] w-[2px] bg-slate-100 dark:bg-slate-800/80 group-last:hidden">
            </div>

            <!-- Avatar Icon -->
            <div
              class="w-7 h-7 rounded-full bg-slate-50 dark:bg-slate-800 border border-slate-200/50 dark:border-slate-700/50 flex items-center justify-center text-slate-400 shrink-0 z-10">
              <span class="material-icons text-sm" [class.text-amber-500]="log.actionType === 'staff_reply'"
                [class.text-slate-500]="log.actionType === 'internal_note'">
                {{ getLogActionIcon(log.actionType) }}
              </span>
            </div>

            <!-- Log Bubble -->
            <div
              class="flex-1 bg-slate-50/50 dark:bg-slate-800/20 rounded-2xl p-2.5 border border-slate-100 dark:border-slate-800/80 space-y-1 hover:shadow-sm transition-shadow min-w-0">

              <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-0.5 text-[11px]">
                <div class="flex items-center gap-2">
                  <span class="font-extrabold text-slate-700 dark:text-slate-350">
                    {{ log.actorUserName || 'System' }}
                  </span>

                  <span *ngIf="log.actionType === 'internal_note'"
                    class="px-2 py-0.5 bg-slate-100 dark:bg-slate-800 text-slate-400 font-black rounded-lg border border-slate-300">
                    บันทึกภายใน
                  </span>
                  <span *ngIf="log.actionType === 'staff_reply'"
                    class="px-2 py-0.5 bg-amber-400/10 text-amber-500 font-black rounded-lg border border-amber-200">
                    ตอบกลับลูกค้า
                  </span>
                </div>

                <span class="text-slate-400 font-medium">
                  {{ log.createDate | date:'dd/MM/yyyy HH:mm' }} น.
                </span>
              </div>

              <p
                class="text-[11px] font-semibold text-slate-800 dark:text-slate-200 leading-relaxed whitespace-pre-line">
                {{
                log.message }}</p>

              <!-- Change status notification sub-message -->
              <div *ngIf="log.actionType === 'status_change'"
                class="text-[12px] font-bold text-slate-450 dark:text-slate-500 flex items-center gap-1">
                <span class="material-icons text-[12px]">arrow_forward</span>
                เปลี่ยนสถานะจาก
                <span class="text-slate-600 dark:text-slate-400">{{ getStatusLabel(log.oldStatus || '') }}</span>
                เป็น
                <span class="text-slate-600 dark:text-slate-400">{{ getStatusLabel(log.newStatus || '') }}</span>
              </div>
            </div>

          </div>

          <div *ngIf="caseDetail.logs?.length === 0" class="py-10 text-center text-[11px] text-slate-400">
            ไม่มีประวัติบันทึกเคสปัญหานี้
          </div>

        </div>

        <!-- Add Reply Form (Footer Input area) -->
        <div *ngIf="canUpdate && caseDetail.status !== 'closed' && caseDetail.status !== 'cancelled'"
          class="border-t border-slate-100 dark:border-slate-800/80 pt-3 shrink-0">
          <div class="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 mb-2 text-[11px] font-bold select-none pl-1">
            <label class="flex items-center gap-2 cursor-pointer group">
              <input type="radio" name="logType" [(ngModel)]="newLogType" value="staff_reply" class="sr-only peer" />
              <div
                class="w-4 h-4 rounded-full border border-slate-300 dark:border-slate-600 peer-checked:flex items-center justify-center bg-white/0 dark:bg-slate-800 peer-checked:border-amber-500 transition-all hidden">
                <div class="w-2 h-2 rounded-full bg-amber-500 scale-100 transition-transform duration-200">
                </div>
              </div>
              <div class="peer-checked:hidden w-4 h-4 rounded-full border border-slate-300"></div>
              <span
                class="text-slate-600 dark:text-slate-350 group-hover:text-slate-800 dark:group-hover:text-slate-200 transition-colors">ตอบกลับลูกค้า
                (เห็นใน LINE)</span>
            </label>
            <label class="flex items-center gap-2 cursor-pointer group ml-3">
              <input type="radio" name="logType" [(ngModel)]="newLogType" value="internal_note" class="sr-only peer" />
              <div
                class="w-4 h-4 rounded-full border border-slate-300 dark:border-slate-600 peer-checked:flex items-center justify-center bg-white/0 dark:bg-slate-800 peer-checked:border-amber-500 transition-all hidden">
                <div class="w-2 h-2 rounded-full bg-amber-500 scale-100 transition-transform duration-200">
                </div>
              </div>
              <div class="peer-checked:hidden w-4 h-4 rounded-full border border-slate-300"></div>
              <span
                class="text-slate-600 dark:text-slate-350 group-hover:text-slate-800 dark:group-hover:text-slate-200 transition-colors">บันทึกความเห็นภายใน
                (Staff เท่านั้น)</span>
            </label>
          </div>

          <div class="flex gap-2">
            <textarea [(ngModel)]="newLogMessage" placeholder="เขียนข้อความตอบกลับ หรือบันทึกโน้ตภายในเคสนี้..."
              rows="2"
              class="w-full text-[11px] font-semibold border border-slate-200 dark:border-slate-700 focus:ring-4 focus:ring-amber-400/20 focus:border-amber-400 rounded-xl p-2.5 outline-none transition-all duration-300 shadow-sm resize-none bg-slate-50/50 dark:bg-slate-800/30 text-slate-750 dark:text-slate-200"></textarea>

            <button (click)="submitStaffReplyLog()" [disabled]="isSavingLog"
              class="px-4 bg-amber-400 hover:bg-amber-500 disabled:bg-slate-100 disabled:text-slate-400 text-slate-900 font-black rounded-xl text-[11px] cursor-pointer transition-all duration-300 hover:shadow-[0_8px_16px_-4px_rgba(251,191,36,0.3)] shrink-0 flex items-center justify-center border-none">
              {{ isSavingLog ? 'บันทึก...' : 'ส่งข้อความ' }}
            </button>
          </div>
        </div>

      </div>

    </div>

  </div>

  <!-- ================= SUB-DIALOG OVERLAY: Reassign Staff ================= -->
  <div *ngIf="showAssignDialog"
    class="fixed inset-0 z-55 flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4 animate-fade-in"
    (click)="showAssignDialog = false">

    <div
      class="bg-white dark:bg-slate-900 w-full max-w-sm rounded-[2rem] shadow-2xl p-6 border border-slate-100 dark:border-slate-800/80 animate-fade-in-up"
      (click)="$event.stopPropagation()">

      <h3 class="text-sm font-extrabold text-slate-900 dark:text-white flex items-center gap-2 mb-4">
        <span class="material-icons text-amber-500">assignment_ind</span>
        มอบหมายเจ้าหน้าที่
      </h3>

      <div class="space-y-4">
        <label class="text-[12px] font-bold text-slate-500 dark:text-slate-400">เลือกผู้รับผิดชอบใหม่</label>
        <div
          class="flex items-center border border-slate-200 dark:border-slate-700 focus-within:ring-4 focus-within:ring-amber-400/20 focus-within:border-amber-400 rounded-2xl px-4 py-2 bg-white dark:bg-slate-800 transition-all shadow-sm">
          <select [(ngModel)]="selectedStaffId"
            class="w-full text-[12px] font-semibold outline-none border-none bg-transparent text-slate-700 dark:text-slate-200">
            <option [ngValue]="null">ไม่มอบหมาย</option>
            <option *ngFor="let u of staffList" [ngValue]="u.id">{{ u.name }} ({{ u.username }})</option>
          </select>
        </div>
      </div>

      <div class="flex gap-3 mt-6">
        <button (click)="showAssignDialog = false"
          class="w-1/2 py-2.5 border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-800 text-slate-600 dark:text-slate-400 font-bold rounded-2xl text-[12px] cursor-pointer transition-colors bg-transparent">
          ยกเลิก
        </button>
        <button (click)="submitAssignment()"
          class="w-1/2 py-2.5 bg-amber-400 hover:bg-amber-500 text-slate-900 font-black rounded-2xl text-[12px] cursor-pointer transition-colors border-none">
          บันทึกมอบหมาย
        </button>
      </div>
    </div>
  </div>

  <!-- ================= SUB-DIALOG OVERLAY: Cancel Case ================= -->
  <div *ngIf="showCancelDialog"
    class="fixed inset-0 z-55 flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4 animate-fade-in"
    (click)="showCancelDialog = false">

    <div
      class="bg-white dark:bg-slate-900 w-full max-w-md rounded-[2rem] shadow-2xl p-6 border border-slate-100 dark:border-slate-800/80 animate-fade-in-up"
      (click)="$event.stopPropagation()">

      <h3 class="text-sm font-extrabold text-rose-500 flex items-center gap-2 mb-4">
        <span class="material-icons text-rose-500">cancel</span>
        ขอยกเลิกเคสประสานงาน
      </h3>

      <div class="space-y-4">
        <label class="text-[12px] font-bold text-slate-500 dark:text-slate-400">กรุณาระบุเหตุผลการยกเลิกเคสนี้ <span
            class="text-rose-500">*</span></label>
        <textarea [(ngModel)]="cancelReason"
          placeholder="ระบุเหตุผล เช่น ลูกค้าโทรแจ้งเปิดซ้ำซ้อน, กรอกข้อมูลไม่ถูกต้อง..." rows="3"
          class="w-full text-[12px] font-semibold border border-slate-200 dark:border-slate-700 focus:ring-4 focus:ring-amber-400/20 focus:border-amber-400 rounded-2xl p-3 outline-none transition-all shadow-sm resize-none bg-slate-50/50 dark:bg-slate-800/30 text-slate-750 dark:text-slate-200"></textarea>
      </div>

      <div class="flex gap-3 mt-6">
        <button (click)="showCancelDialog = false"
          class="w-1/2 py-2.5 border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-800 text-slate-600 dark:text-slate-400 font-bold rounded-2xl text-[12px] cursor-pointer transition-colors bg-transparent">
          ย้อนกลับ
        </button>
        <button (click)="submitCancellation()"
          class="w-1/2 py-2.5 bg-rose-500 hover:bg-rose-600 text-white font-black rounded-2xl text-[12px] cursor-pointer transition-colors border-none">
          ยืนยันยกเลิกเคส
        </button>
      </div>
    </div>
  </div>

  <!-- ================= SUB-DIALOG OVERLAY: Update Case Status ================= -->
  <div *ngIf="showStatusDialog"
    class="fixed inset-0 z-55 flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4 animate-fade-in"
    (click)="showStatusDialog = false">

    <div
      class="bg-white dark:bg-slate-900 w-full max-w-lg rounded-[2rem] shadow-2xl p-6 border border-slate-100 dark:border-slate-800/80 animate-fade-in-up"
      (click)="$event.stopPropagation()">

      <h3 class="text-sm font-extrabold text-slate-900 dark:text-white flex items-center gap-2 mb-4">
        <span class="material-icons text-amber-500">sync_alt</span>
        ปรับเปลี่ยนสถานะของเคสงานเป็น: {{ getStatusLabel(targetStatus) }}
      </h3>

      <div class="space-y-4">
        <!-- Message field (required) -->
        <div class="space-y-2">
          <label class="text-[12px] font-bold text-slate-500 dark:text-slate-400">รายละเอียดบันทึกการเปลี่ยนสถานะ <span
              class="text-rose-500">*</span></label>
          <textarea [(ngModel)]="statusMessage" placeholder="กรอกความคืบหน้า รายละเอียดของการเปลี่ยนสถานะครั้งนี้..."
            rows="3"
            class="w-full text-[12px] font-semibold border border-slate-200 dark:border-slate-700 focus:ring-4 focus:ring-amber-400/20 focus:border-amber-400 rounded-2xl p-3 outline-none transition-all shadow-sm resize-none bg-slate-50/50 dark:bg-slate-800/30 text-slate-750 dark:text-slate-200"></textarea>
        </div>

        <!-- Resolution Summary (required when closing) -->
        <div *ngIf="targetStatus === 'closed' || targetStatus === 'awaiting_customer_confirm'" class="space-y-2">
          <label class="text-[12px] font-bold text-slate-500 dark:text-slate-400">
            สรุปผลการแก้ไขปัญหา (Resolution Summary) <span class="text-rose-500">*</span>
          </label>
          <p class="text-[12px] text-slate-450 dark:text-slate-500">
            ข้อมูลนี้จะถูกส่งแจ้งลูกค้าทาง LINE เมื่อปิดงาน</p>
          <textarea [(ngModel)]="resolutionSummary"
            placeholder="ระบุการดำเนินงานสรุปสุดท้าย เช่น โอนยอดเงินคืนเรียบร้อย 200 บาท วันที่ 14/07 เวลา 12:30 น...."
            rows="3"
            class="w-full text-[12px] font-semibold border border-slate-200 dark:border-slate-700 focus:ring-4 focus:ring-amber-400/20 focus:border-amber-400 rounded-2xl p-3 outline-none transition-all shadow-sm resize-none bg-slate-50/50 dark:bg-slate-800/30 text-slate-750 dark:text-slate-200"></textarea>
        </div>
      </div>

      <div class="flex gap-3 mt-6">
        <button (click)="showStatusDialog = false"
          class="w-1/2 py-2.5 border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-800 text-slate-600 dark:text-slate-400 font-bold rounded-2xl text-[12px] cursor-pointer transition-colors bg-transparent">
          ย้อนกลับ
        </button>
        <button (click)="submitStatusChange()" [disabled]="isSubmittingStatus"
          class="w-1/2 py-2.5 bg-amber-400 hover:bg-amber-500 disabled:bg-slate-200 disabled:text-slate-400 text-slate-900 font-black rounded-2xl text-[12px] cursor-pointer transition-colors border-none">
          {{ isSubmittingStatus ? 'กำลังบันทึก...' : 'ยืนยันการเปลี่ยนแปลง' }}
        </button>
      </div>
    </div>
  </div>

  <!-- Image preview lightbox -->
  <div *ngIf="previewImageUrl"
    class="fixed inset-0 z-[60] flex items-center justify-center bg-slate-950/80 backdrop-blur-sm p-4 animate-fade-in"
    (click)="$event.stopPropagation()">
    <button type="button" (click)="closeImagePreview()"
      class="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors cursor-pointer border-none"
      title="ปิดรูป">
      <span class="material-icons">close</span>
    </button>
    <img [src]="previewImageUrl" alt="preview"
      class="max-h-[85vh] max-w-[min(90vw,720px)] rounded-2xl shadow-2xl object-contain border border-white/10" />
  </div>

</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && caseId"
  [entityType]="activityEntityTypes.ServiceCase"
  [entityId]="caseId"
  title="ประวัติเคส CS"
  [subtitle]="'#' + caseId"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>